import { useState } from 'react';
import axios from 'axios';

/**
 * useRecaptcha - Custom hook for handling Google Recaptcha
 * @param {string} apptType - Optional parameter for the type of appointment (RTA)
 * @param {string} branchID - Optional parameter for the branch ID (RTA)
 * @returns {object} - Returns an object with the following properties:
 *    - captchaToken: The token generated by Google Recaptcha
 *    - setCaptchaToken: Function to set the token
 *    - verifyRecaptchaToken: Function to verify the token (returns an object with success and error properties)
 */
export const useRecaptcha = (apptType, branchID) => {
	const [captchaToken, setCaptchaToken] = useState(null);

	const verifyRecaptchaToken = async () => {
		let response;

		try {
			const body = { recaptcha_response: captchaToken };

			if (apptType) {
				body.apptype = apptType;
			}

			if (branchID) {
				body.branchID = branchID;
			}

			response = await axios.post(`${process.env.GATSBY_AWS_API_URL}/captcha/google/verify`, body);

			if (response.status === 200) {
				return { success: true };
			} else {
				return { success: false, error: response.data?.error?.message };
			}
		} catch (error) {
			return { success: false, error: error.message };
		}
	};

	return { captchaToken, setCaptchaToken, verifyRecaptchaToken };
};
